module.exports = __webpack_public_path__ + "static/img/20.9e7af04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/20.png
// module id = Vci7
// module chunks = 0